export const PRODUCT_CONDITION = [{
	value: 'NEW', name: 'Newseal'
}, {
	value: 'LIKE_NEW', name: 'Likenew'
}, {
	value: 'NEW_REFURBISHED', name: 'New refurbished'
}];
// Newseal, New refurbished , Likenew
export const PURCHASE_ORDER_STATUS = [
	{
		value: '1',
		name: 'Đang giao dịch',
		color: '#e49c06'
	},
	{
		value: '2',
		name: 'Hoàn thành',
		color: '#0db473'
	},
	{
		value: '3',
		name: 'Kết thúc',
		color: '#5364fe'
	}
];

export const REFUND_STATUS = [
	{
		value: '1',
		name: 'Đã hoàn toàn bộ',
		color: '#e49c06'
	},
	{
		value: '2',
		name: 'Đã hoàn 1 phần',
		color: '#0db473'
	},
	{
		value: '-1',
		name: 'Chưa hoàn',
		color: '#5364fe'
	}
];

export const PAYMENT_METHOD = {
	CASH: 'Thanh toán tiền mặt',
	TRANSFER_MONEY: 'Chuyển khoản',
	SWIPE_CARD: 'Thanh toán qua thẻ'
};

export const GENDER = [
	{
		value: '1',
		name: 'Nam'
	},
	{
		value: '-1',
		name: 'Nữ'
	},
	{
		value: '0',
		name: 'Khác'
	}
];

export const TICKET_TYPE = {
	'1': 'Tạo phiếu thu',
	'2': 'Tạo phiếu chi',
	'3': 'Tạo phiếu nhập hàng',
	'4': 'Tạo phiếu trả hàng',
	'5': 'Khởi tạo nhà cung cấp',
	'6': 'Tạo đơn',
	'7': 'Thanh toán',
	'8': 'Hủy đơn',
	'9': 'Hoàn trả'
};

export const SOURCE_ORDER = [
	{ 'value': 'WEBSITE', 'name': 'Website' },
	{ 'value': 'TIKTOK', 'name': 'Tiktok' },
	{ 'value': 'INSTAGRAM', 'name': 'Instagram' },
	{ 'value': 'SHOPEE', 'name': 'Shopee' },
	{ 'value': 'TIKI', 'name': 'Tiki' },
	{ 'value': 'LAZADA', 'name': 'Lazada' },
	{ 'value': 'ZALO', 'name': 'Zalo' },
	{ 'value': 'FACEBOOK', 'name': 'Facebook' },
	{ 'value': 'KHAC', 'name': 'Khác' }
];

export const ORDER_STATUS = [
	{ value: 'COMPLETED', name: 'Hoàn thành', color: 'green' },
	{ value: 'PAID', name: 'Hoàn trả', color: 'blue' },
	{ value: 'PROCESSING', name: 'Đang xử lý', color: 'orange' },
	{ value: 'CANCELED', name: 'Đã hủy', color: 'red' }
];

export const PRODUCT_ACTION = [
	{ 'name': 'Hoàn tiền', 'value': 'REFUND' },
	{ 'name': 'Nhập hàng', 'value': 'IMPORT' },
	{ 'name': 'Xuất cho khách hàng', 'value': 'EXPORT_TO_CUSTOMER' },
	{ 'name': 'Khởi tạo', 'value': 'INIT' }
];
